//Разметка выпадающего списка

import React from 'react';

export function InputSelect (props) {
 
  return (
    <option onChange={props.onChange}>{props.item.nameRu}</option>
  )
}

export function InputSelectEn (props) {
 
  return (
    <option value={props.item.nameEn}>{props.item.nameRu}</option>
  )
}
